import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const HorizontalCardTitle = styled.div<{
  hasInfo?: boolean;
  progressBar?: boolean;
}>`
  display: -webkit-box;
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${30 * Screen.widthRatio}px;
  line-height: ${34 * Screen.widthRatio}px;
  max-height: ${72 * Screen.widthRatio}px;
  overflow: hidden;
  padding-right: ${25 * Screen.widthRatio}px;
  position: relative;
  text-align: right;
  text-overflow: ellipsis;
  text-shadow: ${1 * Screen.widthRatio}px ${1 * Screen.widthRatio}px ${
  4 * Screen.widthRatio
}px black;
  width: ${295 * Screen.widthRatio}px};
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  top: ${(props) => (!props.hasInfo && props.progressBar ? 20 : 0)}px
`;

export default HorizontalCardTitle;
